import { render, staticRenderFns } from "./navFooter.vue?vue&type=template&id=76924934&scoped=true&"
import script from "./navFooter.vue?vue&type=script&lang=js&"
export * from "./navFooter.vue?vue&type=script&lang=js&"
import style0 from "./navFooter.vue?vue&type=style&index=0&id=76924934&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76924934",
  null
  
)

export default component.exports